import React from 'react';
import { StyledSearchInput, Container, DiscardButtonContainer } from './style';
import { Icon } from '../../Icons/Icons';

export const SearchInput = ({ label, placeholder, name, onChange, value, disabled, onDiscard }) => {
    return (
        <Container>
            {/* {label && <StyledLabel htmlFor={name}>{label}</StyledLabel>} */}
            <StyledSearchInput
                type={'text'}
                name={name}
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
            />
            {value.length > 0 && (
                <DiscardButtonContainer onClick={onDiscard}>
                    <Icon.Box size={'10x10'}>
                        <Icon.Close />
                    </Icon.Box>
                </DiscardButtonContainer>
            )}
        </Container>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/SearchInput/SearchInput.js